export const PAGES = [
  {
    src: '/brochure/page-1.webp',
    alt: 'Copertina - Trinity Masterclass, Anno Accademico 2026-2027',
    label: 'Copertina',
  },
  {
    src: '/brochure/page-5.webp',
    alt: 'Chi siamo - Amici per la Musica APS e i docenti',
    label: 'Chi Siamo',
  },
  {
    src: '/brochure/page-2.webp',
    alt: 'Le nostre Masterclass - offerta didattica 2026-2027',
    label: 'Le Masterclass',
  },
  {
    src: '/brochure/page-3.webp',
    alt: 'Insegnanti e costi delle masterclass',
    label: 'Insegnanti e Costi',
  },
  {
    src: '/brochure/page-4.webp',
    alt: 'Sede dei corsi e come partecipare',
    label: 'Sedi e Iscrizioni',
  },
  {
    src: '/brochure/page-6.webp',
    alt: 'Contatti - informazioni, iscrizioni, docenti e social',
    label: 'Contatti',
  },
];
